export const translateFilterFinanceiro = (
  dataInicio: string,
  dataFim: string,
  extra?: Record<string, any>,
): string =>
  JSON.stringify({ data_inicio: dataInicio, data_fim: dataFim, ...(extra ?? {}) });

export const currencyFormat = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});
